// src/components/SignIn.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../NotificationContext';
import { BASE_URI } from '../Config';

const PasswordResetRequest: React.FC = () => {
    const navigate = useNavigate(); // Initialize the hook

    const [email, setEmail] = useState("");
    const { pushMessage } = useNotifications();

    // console.log(userRole);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        // For now, we'll just log the user data. You can add API calls or other logic here later.

        console.log(email);

        const userData = { email };

        try {
            const response = await fetch(`${BASE_URI}/send_password_reset_email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userData)
            });

            const data = await response.json();
            console.log(data);

            if (data.success) {
                pushMessage({text: "Password reset request sent to email, if email is registered", type: "notification"})
                navigate("/signin") // This will probably be email verifcation page??
                // Redirect or perform other actions after successful signup
            } else {
                pushMessage({text: "Something went wrong", type: "error"})
            }
        } catch (error) {
            pushMessage({text: "Something went wrong", type: "error"})
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <h3>Reset Password</h3>
            <div>
                <label>Email: </label>
                <input type="text" value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <input type="submit" value="Reset password"></input>
        </form>
    );
}

export default PasswordResetRequest;
